import { useMemo } from 'react';
import QRCode from 'qrcode';

/**
 * The verify-link QR (Issued artboard): rendered as an inline SVG path from
 * the same encoder the PDF uses (`qrcode`), so no image request and no
 * `data:` URL is needed under the strict CSP.
 */
export function QrCode({
  value,
  size = 72,
  label,
}: {
  value: string;
  size?: number;
  label: string;
}) {
  const { path, n } = useMemo(() => {
    const code = QRCode.create(value, { errorCorrectionLevel: 'M' });
    const modules = code.modules;
    const count = modules.size;
    let d = '';
    for (let row = 0; row < count; row++) {
      for (let col = 0; col < count; col++) {
        if (modules.get(row, col)) d += `M${col} ${row}h1v1H${col}z`;
      }
    }
    return { path: d, n: count };
  }, [value]);
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${n} ${n}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label={label}
      className="shrink-0"
    >
      <rect width={n} height={n} className="fill-surface" />
      <path d={path} className="fill-ink" />
    </svg>
  );
}
